<div class="add-card-container">
    <div class="add-card-header checkout-title">
        <span class="material-symbols-rounded square-icon">
            credit_card
        </span>
        <div class="ms-3">
            <h5 class="app-module-title m-0"><strong>Agregar forma de pago</strong></h5>
            <!-- <p class="small-label">Tarjeta de debito o credito vigente</p> -->
        </div>
    </div>

    <div class="add-card-content">
        <div class="h-100" [hidden]="checkoutIsReady || unableToLoadFrame">
            <div class="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
                <mat-spinner class="mb-4" mode="indeterminate" ></mat-spinner>
                <p class="medium-text"><strong>Conectando</strong></p>
                <p class="small-label">Un momento por favor</p>
            </div>
        </div>
        <div *ngIf="unableToLoadFrame">
            <div class="d-flex flex-column w-100 alert alert-danger">
                <h5 class="text-danger"><strong>Problema al cargar pagina</strong></h5>
                <p class="small-label retry-desc">
                    Intentamos cargar el contenido varias veces pero no fue posible.
                    Es posible que tu red este limitada o el servicio de alta de tarjetas este presentando problemas.
                    Si el problema continua. Puedes seleccionar pago en Terminal.
                </p>
                <button mat-flat-button
                        class="retry-btn w-100 mt-4">
                    Intentar de nuevo
                </button>
            </div>
        </div>
        <div #conektaIframeContainer id="conektaIframeContainer"
             [hidden]="!checkoutIsReady || onTokenizedCard || unableToLoadFrame"
             [style.height]="'100%'">
        </div>
    </div>

    <div class="add-card-bottom mb-4">
        <button mat-flat-button
            class="add-card-cancel-btn w-100"
            (click)="cancelCardAdding()">
            <span class="material-symbols-rounded">close</span>
            <strong>Cancelar y regresar a checkout</strong>
        </button>
    </div>
</div>
